// The small ? beside a setting's name in the chat's menu (Fixes 8, David: "far fewer words ... the explanation goes in a
// small ? beside the label (a tooltip on hover or tap)"). Its words show on hover, on keyboard focus and on a tap, which
// a phone needs, and a second tap or moving on puts them away.

import { useState } from "react";
import { CircleHelp } from "lucide-react";
import { cx } from "../lib/util";

export function Why({ text }: { text: string }) {
  const [open, setOpen] = useState(false);
  return (
    <button
      type="button"
      className={cx("chat-why", open && "is-open")}
      aria-label={text}
      data-tip={text}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(!open);
      }}
      onBlur={() => setOpen(false)}
    >
      <CircleHelp size={12} aria-hidden />
    </button>
  );
}
